import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';

// neuro の AI Assist チャット (StreamingIndicator) と揃えたローディング表示。
export function AnalyzingIndicator({ label }: { label: string }): ReactElement {
  const [active, setActive] = useState(0);
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const dotId = setInterval(() => setActive((prev) => (prev + 1) % 3), 400);
    const secId = setInterval(() => setElapsed((prev) => prev + 1), 1000);
    return () => {
      clearInterval(dotId);
      clearInterval(secId);
    };
  }, []);

  return (
    <div className="inline-flex items-center gap-2 rounded-2xl bg-blue-50 px-3 py-2">
      <div className="flex items-center gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="inline-block size-2 rounded-full transition-all duration-300"
            style={{
              background: i === active ? '#2563eb' : '#93c5fd',
              transform: i === active ? 'scale(1.3)' : 'scale(0.8)',
            }}
          />
        ))}
      </div>
      <span className="text-xs font-medium text-blue-600">
        {label}（{elapsed}秒）
      </span>
    </div>
  );
}
